import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { authPageSettings } from "../../actions/catalog";
import { withRouter } from "react-router-dom";
import WasCreatedModal from "./WasCreatedModal";

class AuthLocked extends React.Component {

    static contextTypes = {
        currentLanguage: PropTypes.object,
        translate: PropTypes.func
    };

    componentWillMount() {
        if (!this.props.pageSettings) {
            this.props.authPageSettings();
        }
    }

    handleUnlock = () => {
        this.props.unlock();
        this.props.history.push({
            pathname: '/recovery',
            state: { recByDs: true }
        });
    };

    handleUnlockNredirect = () => {
        this.props.unlock();
        this.props.history.push({
            pathname: '/recovery',
            state: { recByDs: false }
        });
    };

    render() {
        let { pageSettings, type } = this.props;
        let content = null;

        switch (type) {
            case -2:
                content = (
                    <div className="auth__form__reg authlocked">
                        <div className="ban-icon" />
                        <h1 className="auth-ban__title">{this.context.translate('Ваш аккаунт заблокирован')}</h1>
                        <p className="auth-ban__subtitle">{this.context.translate('Восстановить доступ в Личный кабинет ДельтаЛизинг Вы можете по следующему телефону')}</p>
                        {pageSettings && (
                            <div className="ban-support">
                                <a target="_blank" style={{ color: "#2B6DE1", fontFamily: 'Manrope' }}
                                    href={pageSettings.support_phone[this.context.currentLanguage.alias] ?
                                        "tel:" + pageSettings.support_phone[this.context.currentLanguage.alias].replace(/\s/g, '') : "#"}>
                                    {pageSettings.support_phone[this.context.currentLanguage.alias]}
                                </a>
                            </div>
                        )}
                    </div>
                );
                break;
            case -1:
                content = (
                    <div className="auth-ban">
                        <div className="ban-icon" />
                        <h1 className="auth-ban__title">{this.context.translate('Ваш аккаунт временно заблокирован')}</h1>
                        <p className="auth-ban__subtitle">
                            Подтвердите доступ с помощью квалифицированной электронной подписи <span style={{ fontWeight: 600, fontFamily: 'Manrope' }}>юридического лица</span>, к которому была привязана ваша учетная запись
                        </p>
                        <div className="auth-ban-links">
                            <button className="btn_auth blocked" onClick={this.handleUnlock}>Восстановить через ЭП</button>
                        </div>
                        <p className="dsignature" onClick={this.handleUnlockNredirect}>Нет электронной подписи?</p>
                        <p className="ban-support">
                            Обратитесь к вашему клиентскому менеджеру или позвоните по номеру <span> </span>
                            <a target="_blank" style={{ color: "#2B6DE1", fontFamily: 'Manrope' }}
                                href={pageSettings && pageSettings.support_phone[this.context.currentLanguage.alias] ?
                                    "tel:" + pageSettings.support_phone[this.context.currentLanguage.alias].replace(/\s/g, '') : "#"}>
                                {pageSettings && pageSettings.support_phone[this.context.currentLanguage.alias]}
                            </a>
                        </p>
                    </div>
                );
                break;
            case -3:
                content = <WasCreatedModal />
                break;
            case -4:
                content = (
                    <div className="auth-ban">
                        <div className="ban-icon" />
                        <h1 className="auth-ban__title">{this.context.translate('Ваш аккаунт заблокирован')}</h1>
                        <p className="auth-ban__subtitle">
                            Подтвердите доступ с помощью квалифицированной электронной подписи <span style={{ fontWeight: 600, fontFamily: 'Manrope' }}>юридического лица</span>, к которому была привязана ваша учетная запись
                        </p>
                        <div className="auth-ban-links">
                            <button className="btn_auth blocked" onClick={this.handleUnlock}>Восстановить через ЭП</button>
                        </div>
                        <p className="dsignature" onClick={this.handleUnlockNredirect}>Нет электронной подписи?</p>
                        <p className="ban-support">
                            Обратитесь к вашему клиентскому менеджеру или позвоните по номеру <span> </span>
                            <a target="_blank" style={{ color: "#2B6DE1", fontFamily: 'Manrope' }}
                                href={pageSettings && pageSettings.support_phone[this.context.currentLanguage.alias] ?
                                    "tel:" + pageSettings.support_phone[this.context.currentLanguage.alias].replace(/\s/g, '') : "#"}>
                                {pageSettings && pageSettings.support_phone[this.context.currentLanguage.alias]}
                            </a>
                        </p>
                    </div>
                );
                break;
            default:
                content = null;
        }

        return (
            <div className="wrapper__auth-ban">
                <div className="auth_ban reg">
                    {content}
                </div>
            </div>
        );
    }


}

export default connect(
    state => ({
        pageSettings: state.catalog && state.catalog.authPageSettings
    }),
    (dispatch) => {
        return {
            authPageSettings: () => dispatch(authPageSettings()),
            unlock: () => dispatch({ type: 'UNLOCK' })
        }
    }
)(withRouter(AuthLocked));